<template>
  <ul :class="computedClass">
    <li
      v-for="(navLink, index) in navigation"
      :key="index"
      :class="{
        'relative m-5px': true,
      }"
    >
      <MicroSiteNavButton
        v-if="navLink._type === 'microSiteNavButton'"
        v-bind="navLink"
        :button-style="buttonStyle"
      />
      <MicroSiteDropdownMenu
        v-else-if="navLink._type === 'microSiteDropdownMenu'"
        v-bind="navLink"
        :button-style="buttonStyle"
      />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import MicroSiteDropdownMenu from '~/features/MicroSite/MicroSiteDropdownMenu.vue';
import MicroSiteNavButton from '~/features/MicroSite/MicroSiteNavButton.vue';
import type { MicroSiteNavigation } from '~/sanity/types';
const props = defineProps<MicroSiteNavigation>();
const { alignment, buttonStyle } = toRefs(props);
const alignmentClass = computed(() => {
  return alignmentClasses[alignment.value ?? 'center'] ?? alignmentClasses['center'];
});
const computedClass = computed(() => [
  'mt-30px flex flex-col flex-wrap items-center md:flex-row',
  alignmentClass.value,
]);
const alignmentClasses: Record<string, string> = {
  left: 'text-left justify-start',
  center: 'text-center justify-center',
  right: 'text-right justify-end',
};
</script>

<style></style>
